export { default as CreditCardIcon } from './credit-card-icon'
